/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';

import { withRouter } from 'react-router-dom';
import '../Krishak/krishak.css'
import { COMMON, HOME_TODAY_SCREEN, CALENDER_SCREEN, PERMISSION_CONSTANTS, SYNC_SERVICE, REPORTS_SCREEN, COMMON_VALUE } from '../../global/Constants'
import { LOGO } from '../../global/Icons';
import { ALL_ROUTES } from '../../global/Constants';
import { MORE_MENU_TYPES, ActivityType } from '../../global/Enum';
import { HeaderTypes } from "../../global/Enum";
import ApiServices from '../../providers/ApiServices';
import Utilities from '../../global/Utilities';
import AuthService from '../../providers/AuthService';
import SyncServices from '../../providers/SyncServices';
import DataProvider from '../../providers/DataProvider';
import { toast } from 'react-toastify';
import Loader from '../common/loader/Loader';
import $ from 'jquery';

const allMasterKeys = [
    SYNC_SERVICE.ACTION_QUALIFICATION,
    SYNC_SERVICE.ACTION_PHONE_APP,
    SYNC_SERVICE.ACTION_IRRIGATION_SOURCE,
    SYNC_SERVICE.ACTION_AREA_UNIT,
    SYNC_SERVICE.ACTION_WEIGHT_UNIT,
    SYNC_SERVICE.ACTION_INFLUENCE_FACTOR,
    SYNC_SERVICE.ACTION_KRISHAK_SOURCE_OF_INFORMATION,
    SYNC_SERVICE.ACTION_KRISHAK_DECISION_MAKING,
    SYNC_SERVICE.ACTION_CROP_DAYS,
    SYNC_SERVICE.ACTION_CROP_PICKING,
    SYNC_SERVICE.ACTION_CROP_PLOT_VISIT_CROP_HEALTH,
    SYNC_SERVICE.ACTION_CROP_QUALITY_GIVEN,
    SYNC_SERVICE.ACTION_CROP_ROW_DISTANCE,
    SYNC_SERVICE.ACTION_CROP_SOWING_SPACING,
    SYNC_SERVICE.ACTION_DAYS,
    SYNC_SERVICE.ACTION_FEEDBACK,
    SYNC_SERVICE.ACTION_FIELD_DAMAGE_REASON,
    SYNC_SERVICE.ACTION_FIELD_DAY_ATTEND,
    SYNC_SERVICE.ACTION_FIELD_DAY_MANAGER,
    SYNC_SERVICE.ACTION_LEVEL,
    SYNC_SERVICE.ACTION_PICKING,
    SYNC_SERVICE.ACTION_PLOT_VISIT_CROP_HEALTH,
    SYNC_SERVICE.ACTION_PLOT_VISIT_STAGE,
    SYNC_SERVICE.ACTION_QUALITY_GIVEN,
    SYNC_SERVICE.ACTION_REJECT,
    SYNC_SERVICE.ACTION_ROW_DISTANCE,
    SYNC_SERVICE.ACTION_SOWING_SPACING,
    SYNC_SERVICE.ACTION_TYPE_OF_SAMPLE,
    SYNC_SERVICE.ACTION_STATE,
    SYNC_SERVICE.ACTION_DISTRICT,
    SYNC_SERVICE.ACTION_TEHSIL,
    SYNC_SERVICE.ACTION_VILLAGE,
    SYNC_SERVICE.ACTION_CROP,
    SYNC_SERVICE.ACTION_HYBRID,
    SYNC_SERVICE.ACTION_HYBRID_LOCATION_TEHSIL,
    SYNC_SERVICE.ACTION_USER_LOCATION,
    SYNC_SERVICE.ACTION_EMPLOYEE,
    SYNC_SERVICE.ACTION_COMPETITOR_HYBRID,
    SYNC_SERVICE.ACTION_RETAILER,
    SYNC_SERVICE.ACTION_SUB_ACTIVITY,
    SYNC_SERVICE.ACTION_SEASON,
    SYNC_SERVICE.ACTION_SAMPLE_TO_SALE_CROP,
    SYNC_SERVICE.ACTION_GROVER,
    SYNC_SERVICE.ACTION_CROP_GROUP,
    SYNC_SERVICE.ACTION_USER_CROP,
    SYNC_SERVICE.ACTION_ERROR_LOG,
    SYNC_SERVICE.ACTION_LEVEL,
    SYNC_SERVICE.ACTION_KRISHAK_CROP,
    SYNC_SERVICE.ACTION_DAKSH_COMPETITOR_HYBRID,
    SYNC_SERVICE.ACTION_CROP_SEASON_SUB_ACTIVITY
]

class Header extends Component {

    constructor(props) {
        super(props);
        this.count = 0;
        this.showSyncMessage = true;
        this.state = {
            isLoading: false,
            selectedTab: HeaderTypes.TODAY,
            mobileNumber: '',
            //notificationCount: 0,
            localDataCount: 0,
        }
        this.krishakData = null;
    }

    async componentDidMount() {
        //toast.configure();
        const { selectedTab } = this.props;
        this.setState({
            selectedTab: selectedTab
        });
        await DataProvider.getInstance().fetchMasterData();

        //this.getUserNotification();

        const { pathname } = this.props.location;
        if (ALL_ROUTES.HOME_TODAY_ROUTE === pathname) {
            //this.syncAllActivityData(false);
            this.getUserNotification();
        }

        this.checkLocalData();
        //this.checkOfflineData();
    }



    componentWillUnmount() {
        // fix Warning: Can't perform a React state update on an unmounted component
        this.setState = (state, callback) => {
            return;
        };
    }

    performSync() {
        this.showSyncMessage = false;
        this.syncAllKrishakData(false);
    }

    checkLocalData = () => {
        SyncServices.getLocalKrishakCount().then(krishakCount => {

            if (krishakCount > 0) {
                this.count = this.count + krishakCount;

                SyncServices.getLocalActivityCount().then(activityCount => {
                    //Utilities.LogPrint("COUNT Activity = ", activityCount);
                    this.count = this.count + activityCount;
                    //Utilities.LogPrint("COUNT Both = ", this.count);
                    this.setState({ localDataCount: this.count })
                });

            } else {
                SyncServices.getLocalActivityCount().then(activityCount => {
                    //Utilities.LogPrint("COUNT Activity = ", activityCount);
                    this.count = activityCount;
                    this.setState({ localDataCount: this.count })
                });
            }
        });
    }

    phoneValidation() {
        const { mobileNumber } = this.state;
        let isValid = true;
        //let pattern = new RegExp(/^[0-9\b]+$/);
        const pattern = /^[0]?[6789]\d{9}$/;
        if (!pattern.test(mobileNumber)) {
            isValid = false;
        } else if (mobileNumber.length !== 10) {
            isValid = false;
        } else {
            isValid = true;
        }
        return isValid;
    }

    verifyNumber = event => {
        const { value } = event.target;
        const mobileNumber = value;
        this.setState({ mobileNumber });
    }

    _handleDashboardClick = () => {
        this.props.history.push(ALL_ROUTES.DASHBOARD_ROUTE);
    }

    _handleTodayClick = () => {
        this.props.history.push(ALL_ROUTES.HOME_TODAY_ROUTE);
    }

    _handleCalendarClick = () => {
        this.props.history.push(ALL_ROUTES.CALENDAR_ROUTE);
    }

    getUserNotification() {
        if (Utilities.isNetworkConnected()) {
            try {
                ApiServices.getUserNotification().then(response => {
                    let status = response.success;
                    if (status) {
                        //this.setState({ notificationCount: response.data.unread });
                        DataProvider.getInstance().setNotificationCount(response.data.unread);
                    }
                }).catch(error => {
                    Utilities.LogPrint("getUserNotification", error);
                });
            } catch (error) {
                Utilities.LogPrint("getUserNotification", error);
            }
        }
    }

    handleUpdateKrishak = () => {
        const data = this.krishakData;
        if (Utilities.isNetworkConnected() && data.krishak_id > 0 && data !== null) {
            this.getKrishakById(data.krishak_id);
        } else {
            if (data.krishak_id === 0) {
                this.goToKrishakPage(data);
            } else {
                toast.info(COMMON.OFFLINE_KRISHAK_EDIT_MESSAGE);
            }
        }
    }

    _handleKrishakClick = () => {
        // New Implementation
        SyncServices.findKrishakFromDatabase("key", this.state.mobileNumber).then(data => {
            if (data) {
                Utilities.LogPrint("getKrishakFromDatabase", data);

                $('#krishakButton').trigger('click');
                this.krishakData = data;

                // if (Utilities.isNetworkConnected() && data.krishak_id > 0) {
                //     this.getKrishakById(data.krishak_id);
                // } else {
                //     if (data.krishak_id === 0) {
                //         this.goToKrishakPage(data);
                //     } else {
                //         toast.info(COMMON.OFFLINE_KRISHAK_EDIT_MESSAGE);
                //     }
                // }
            } else {
                Utilities.LogPrint("getKrishakFromDatabase", "no");
                this.props.history.push({
                    pathname: ALL_ROUTES.ADD_KRISHAK_ROUTE,
                    state: { mobileNumber: this.state.mobileNumber }
                });
            }
        });

        // Old Implementation By Sanjay
        // SyncServices.findKrishakFromDatabase("key", this.state.mobileNumber).then(data => {
        //     if (data) {
        //         Utilities.LogPrint("getKrishakFromDatabase", data);
        //         if (data.is_active === undefined || data.is_active === null || data.is_active === 1 || data.is_active === true) {
        //             this.props.history.push({
        //                 pathname: ALL_ROUTES.ADD_KRISHAK_ROUTE,
        //                 state: { krishakInfo: data }
        //             });
        //         } else {
        //             this.props.history.push({
        //                 pathname: ALL_ROUTES.ADD_KRISHAK_ROUTE,
        //                 state: { mobileNumber: this.state.mobileNumber }
        //             });
        //         }
        //     } else {
        //         Utilities.LogPrint("getKrishakFromDatabase", "no");
        //         this.props.history.push({
        //             pathname: ALL_ROUTES.ADD_KRISHAK_ROUTE,
        //             state: { mobileNumber: this.state.mobileNumber }
        //         });
        //     }
        // });
    }

    goToKrishakPage = (krishakInfo) => {
        this.props.history.push({
            pathname: ALL_ROUTES.ADD_KRISHAK_ROUTE,
            state: { krishakInfo: krishakInfo }
        });
    }

    getKrishakById = (krishakId) => {
        this.setState({ isLoading: true });
        var params = JSON.stringify({
            krishak_id: krishakId,
            phone: this.state.mobileNumber,
        });
        try {
            ApiServices.getKrishakByReferenceId(params).then(response => {
                this.setState({ isLoading: false });
                var status = response.success;
                if (status) {
                    const krishakInfo = response.data;
                    if (krishakInfo != null) {
                        this.goToKrishakPage(krishakInfo);
                    }
                } else {

                }

            }).catch(error => {
                Utilities.LogPrint("getKrishakById", error);
            });
        } catch (error) {
            this.setState({ isLoading: false });
            Utilities.LogPrint("getKrishakById", error);
        }
    }


    _handleSyncClick = () => {
        if (Utilities.isNetworkConnected()) {
            this.syncAllMasterData();
        } else {
            toast.info(COMMON.NO_INTERNET_CONNECTION);
        }
    }

    //OFFLINE LOGIC
    syncAllKrishakData = async () => {
        this.props.handleSyncLoading(true, SYNC_SERVICE.KRISHAK_TABLE);
        SyncServices.getKrishakFromDatabase("is_synced", "false").then(async data => {
            if (data && data.length > 0) {
                Utilities.LogPrint("UnsyncedData", data);
                this.props.handleSyncLoading(true, SYNC_SERVICE.KRISHAK_TABLE);
                let krishaksForUpdate = [];
                const formData = new FormData();
                const lastSyncDate = localStorage.getItem(SYNC_SERVICE.LAST_SYNC_DATE);

                for (let i = 0; i < data.length; i++) {
                    const krishak = data[i].data;

                    delete krishak?.krishak_images;

                    let yourdate = krishak.dob.split("/").reverse();
                    let tmp = yourdate[2];
                    yourdate[2] = yourdate[1];
                    yourdate[1] = tmp;
                    yourdate = yourdate.join("-");
                    yourdate = yourdate.replace("--", "")

                    if (krishak.prerak_name_phone.krishak_id !== undefined) {
                        krishak.prerak_name_phone = krishak.prerak_name_phone.krishak_id.toString();
                    } else {
                        krishak.prerak_name_phone = "[]";
                    }
                    krishak.dob = yourdate;

                    krishaksForUpdate.push(krishak);
                    for (let j = 0; j < krishak.imagesFiles.length; j++) {
                        formData.append("krishak_image", krishak.imagesFiles[j].file);

                    }
                    for (let k = 0; k < krishak.farmer_mobile_images_files.length; k++) {
                        formData.append("krishak_fellow_farmer_image", krishak.farmer_mobile_images_files[k].file);

                    }
                }
                Utilities.LogPrint("krishaksForUpdate", krishaksForUpdate);
                let lst_sync = [
                    {
                        action: "krishak",
                        last_sync_date: lastSyncDate,
                        data: krishaksForUpdate
                    }
                ]
                formData.append("lst_sync", JSON.stringify(lst_sync));

                try {
                    ApiServices.syncKrishakData(formData)
                        .then(async response => {
                            Utilities.LogPrint("API_DATA syncData: ---->", response);
                            this.props.handleSyncLoading(true, SYNC_SERVICE.KRISHAK_TABLE);
                            this.getAllKrishak();
                            if (response.success) {
                                Utilities.LogPrint("Status", response.data);
                                let data = response.data;
                                let KEY = SYNC_SERVICE.ACTION_KRISHAK;
                                let findKrishakActionData = data.find(item => item.action === KEY);
                                Utilities.LogPrint('JIGS', findKrishakActionData.data);

                                for (let i = 0; i < findKrishakActionData.data.length; i++) {
                                    let krishak = findKrishakActionData.data[i];
                                    SyncServices.addKrishakToDatabase(
                                        krishak,
                                        krishak.phone,
                                        krishak.is_prerak === 1 ? "true" : "false",
                                        krishak.krishak_id.toString(),
                                        "0"
                                    );
                                }
                            } else {
                                Utilities.LogPrint("Status", response.message);
                            }
                        }).catch(error => {
                            this.getAllKrishak();
                            this.props.handleSyncLoading(true, SYNC_SERVICE.KRISHAK_TABLE);
                            Utilities.LogPrint("Status-Catch", error);
                        });
                } catch (error) {
                    this.props.handleSyncLoading(true, SYNC_SERVICE.KRISHAK_TABLE);
                    this.getAllKrishak();
                    Utilities.LogPrint("Status-Error", error);
                }

            } else {
                this.getAllKrishak();
            }
        });
        // this.getAllKrishak();
    }

    syncAllMasterData = () => {
        //const { allMasterKeys } = this.state;
        let images = [];
        let fellowFarmerImages = [];
        const formData = new FormData();
        let lst_sync = [];
        // const lastSyncDate = localStorage.getItem(SYNC_SERVICE.LAST_SYNC_DATE);
        const lastSyncDate = "2020-01-01 00:00:00";
        for (let i = 0; i < allMasterKeys.length; i++) {
            lst_sync.push({
                action: allMasterKeys[i],
                last_sync_date: lastSyncDate,
                data: []
            })
        }

        formData.append("lst_sync", JSON.stringify(lst_sync));
        for (let i = 0; i < images.length; i++) {
            formData.append("krishak_image", images[i]);
        }
        for (let i = 0; i < fellowFarmerImages.length; i++) {
            formData.append("krishak_fellow_farmer_image", fellowFarmerImages[i]);
        }
        this.props.handleSyncLoading(true, SYNC_SERVICE.MASTER_TABLE);
        try {
            ApiServices.syncData(formData)
                .then(async response => {
                    Utilities.LogPrint("allMasterDataResponse", response);
                    this.props.handleSyncLoading(true, SYNC_SERVICE.MASTER_TABLE);
                    if (response.success) {
                        Utilities.LogPrint("Status", response.data);
                        let data = response.data;

                        for (let j = 0; j < allMasterKeys.length; j++) {
                            let masterData = data.find(item => item.action === allMasterKeys[j]);
                            let masterArray = masterData.data;
                            if (masterArray.length > 0) {
                                //Utilities.LogPrint('AllMasterData', masterArray);
                                //let dataArray = await SyncServices.getDataFromDatabase(allMasterKeys[j], SYNC_SERVICE.MASTER_TABLE)
                                //Utilities.LogPrint('AllMasterDataArray', dataArray);
                                SyncServices.addMasterToDatabase(masterArray, allMasterKeys[j]);

                                // let arrayToAdd = dataArray.slice();
                                // if (dataArray === undefined || dataArray === null || dataArray.length === 0) {
                                //     SyncServices.addMasterToDatabase(masterArray, allMasterKeys[j]);
                                // } else {
                                //     for (let k = 0; k < masterArray.length; k++) {
                                //         let dataObject = masterArray[k];
                                //         let presentObject = dataArray.find(item => item.created_at === dataObject.created_at);
                                //         let presentIndex = dataArray.findIndex(item => item.created_at === dataObject.created_at);
                                //         if (dataObject.modified_at !== presentObject.modified_at) {
                                //             arrayToAdd[presentIndex] = dataObject;
                                //             Utilities.LogPrint('UpdatedObject', dataObject);
                                //         }
                                //         Utilities.LogPrint('presentObject', presentObject);
                                //         Utilities.LogPrint('presentIndex', presentIndex);
                                //     }
                                //     SyncServices.addMasterToDatabase(arrayToAdd, allMasterKeys[j]);
                                // }
                            }
                        }
                        this.syncAllKrishakData();

                    } else {
                        if (response.message === COMMON.TOKEN_EXPIRED) {
                            Utilities.tokenExpiredRedirectToLogin();
                        }
                        Utilities.LogPrint("Status", response.message);
                    }
                }).catch(error => {
                    this.syncAllKrishakData();
                    Utilities.LogPrint("Status-Catch", error);
                });
        } catch (error) {
            this.syncAllKrishakData();
            Utilities.LogPrint("Status-Error", error);
        }
    }

    getAllKrishak = async () => {
        const formData = new FormData();

        const lastSyncDate = localStorage.getItem(SYNC_SERVICE.LAST_SYNC_DATE);

        let lst_sync = [
            {
                action: "krishak",
                last_sync_date: lastSyncDate,
                data: []
            }
        ]
        formData.append("lst_sync", JSON.stringify(lst_sync));

        this.props.handleSyncLoading(true, SYNC_SERVICE.KRISHAK_TABLE);
        try {
            ApiServices.syncKrishakData(formData)
                .then(async response => {
                    Utilities.LogPrint("KrishaksyncData", response);
                    this.props.handleSyncLoading(true, SYNC_SERVICE.KRISHAK_TABLE);
                    this.syncAllActivityData(true);
                    if (response.success) {
                        Utilities.LogPrint("Status", response.data);
                        let data = response.data;
                        let KEY = SYNC_SERVICE.ACTION_KRISHAK;
                        let findKrishakActionData = data.find(item => item.action === KEY);
                        Utilities.LogPrint('JIGS', findKrishakActionData.data);

                        for (let i = 0; i < findKrishakActionData.data.length; i++) {
                            let krishak = findKrishakActionData.data[i];
                            SyncServices.addKrishakToDatabase(
                                krishak,
                                krishak.phone,
                                krishak.is_prerak === 1 ? "true" : "false",
                                krishak.krishak_id.toString(),
                                "0"
                            );
                        }
                    } else {
                        Utilities.LogPrint("Status", response.message);
                    }
                }).catch(error => {
                    this.syncAllActivityData(true);
                    this.props.handleSyncLoading(true, SYNC_SERVICE.KRISHAK_TABLE);
                    Utilities.LogPrint("Status-Catch", error);
                });
        } catch (error) {
            this.syncAllActivityData(true);
            this.props.handleSyncLoading(true, SYNC_SERVICE.KRISHAK_TABLE);
            Utilities.LogPrint("Status-Error", error);
        }
    }

    //OFFLINE SYNC Activity LOGIC
    syncAllActivityData(showLoading) {
        SyncServices.storeSampleToSaleById();

        const activities = new Promise(function (resolve) {
            SyncServices.getLocalActivities("is_synced", "false").then(activities => {
                Utilities.LogPrint("Local Activities ===============", activities);

                let activityArray = [];
                if (activities != null || activities?.length > 0) {
                    for (let i = 0; i < activities.length; i++) {
                        const activity = activities[i];

                        if (activity?.activity_type_id === ActivityType.INDIVIDUAL_VISIT) {

                            // For Activity IV Image
                            let activity_image = [];
                            for (let j = 0; j < activity?.data?.activity_images.length; j++) {
                                const objImage = activity?.data?.activity_images[j];
                                if (objImage.image_id === 0) {
                                    let obj = {
                                        temp_image_id: objImage.temp_image_id,
                                        name: objImage.name
                                    }
                                    activity_image.push(obj);
                                }
                            }

                            // For Activity Delete Image
                            if (activity?.data?.deletedImages.length > 0) {
                                const deletedImages = activity?.data?.deletedImages;
                                for (let i = 0; i < deletedImages?.length; i++) {
                                    const objImage = deletedImages[i];
                                    activity_image.push(objImage);
                                }
                            }
                            Utilities.LogPrint("Image", activity_image);

                            let objRequest = {};
                            if (activity?.data === null) {
                                objRequest = {
                                    temp_activity_id: activity?.key,
                                    activity_id: activity?.activity_id,
                                    activity_date: activity?.created_at,
                                    activity_type_id: activity?.activity_type_id,
                                    activity_status_id: activity?.activity_status_id,
                                    assigned_user_id: activity?.assigned_user_id,
                                    crop_id: activity?.crop_id,
                                    hybrid_id: activity?.hybrid_id,
                                    village_id: activity?.village_id,
                                    krishak_id: activity?.krishak_id,
                                    retailer_id: activity?.retailer_id,
                                    is_active: activity?.is_active,
                                }
                            } else {
                                objRequest = {
                                    temp_activity_id: activity?.key,
                                    activity_id: activity?.activity_id,
                                    activity_date: activity?.created_at,
                                    activity_type_id: activity?.activity_type_id,
                                    activity_status_id: activity?.activity_status_id,
                                    assigned_user_id: activity?.assigned_user_id,
                                    crop_id: activity?.crop_id,
                                    hybrid_id: activity?.hybrid_id,
                                    village_id: activity?.village_id,
                                    krishak_id: activity?.krishak_id,
                                    retailer_id: activity?.retailer_id,
                                    temp_krishak_id: activity?.temp_krishak_id,
                                    temp_krishak_phone: activity?.temp_krishak_phone,
                                    is_active: activity?.is_active,
                                    data: {
                                        activity_id: activity?.data?.activity_id,
                                        krishak_id: activity?.data?.krishak_id,
                                        retailer_id: activity?.data?.retailer_id,
                                        temp_krishak_id: activity?.temp_krishak_id,
                                        season_id: activity?.data?.season_id,
                                        sub_activity_id: activity?.data?.sub_activity_id,
                                        remark: activity?.data?.remark,
                                        latitude: activity?.data?.latitude,
                                        longitude: activity?.data?.longitude,
                                        activity_image: activity_image
                                    }
                                }
                            }
                            activityArray.push(objRequest);
                        }

                        if (activity?.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
                            // For Activity SD Image
                            let activity_image = [];
                            for (let j = 0; j < activity?.data?.activity_images.length; j++) {
                                const objImage = activity?.data?.activity_images[j];
                                if (objImage.image_id === 0) {
                                    let obj = {
                                        temp_image_id: objImage.temp_image_id,
                                        name: objImage.name
                                    }
                                    activity_image.push(obj);
                                }
                            }

                            // For Activity Delete Image
                            if (activity?.data?.deletedImages.length > 0) {
                                const deletedImages = activity?.data?.deletedImages;
                                for (let i = 0; i < deletedImages?.length; i++) {
                                    const objImage = deletedImages[i];
                                    activity_image.push(objImage);
                                }
                            }
                            Utilities.LogPrint("Image", activity_image);

                            let objRequest = {}
                            if (activity?.data === null) {
                                objRequest = {
                                    temp_activity_id: activity?.key,
                                    activity_id: activity?.activity_id,
                                    activity_date: activity?.created_at,
                                    activity_type_id: activity?.activity_type_id,
                                    activity_status_id: activity?.activity_status_id,
                                    assigned_user_id: activity?.assigned_user_id,
                                    crop_id: activity?.crop_id,
                                    hybrid_id: activity?.hybrid_id,
                                    village_id: activity?.village_id,
                                    krishak_id: activity?.krishak_id,
                                    retailer_id: activity?.retailer_id,
                                    is_active: activity?.is_active,
                                    //data: activity?.data
                                }
                            } else {
                                objRequest = {
                                    temp_activity_id: activity?.key,
                                    activity_id: activity?.activity_id,
                                    activity_date: activity?.created_at,
                                    activity_type_id: activity?.activity_type_id,
                                    activity_status_id: activity?.activity_status_id,
                                    assigned_user_id: activity?.assigned_user_id,
                                    crop_id: activity?.crop_id,
                                    hybrid_id: activity?.hybrid_id,
                                    village_id: activity?.village_id,
                                    krishak_id: activity?.krishak_id,
                                    retailer_id: activity?.retailer_id,
                                    temp_krishak_id: activity?.temp_krishak_id,
                                    temp_krishak_phone: activity?.temp_krishak_phone,
                                    is_active: activity?.is_active,
                                    data: {
                                        activity_id: activity?.activity_id,
                                        krishak_id: activity?.data?.krishak_id,
                                        temp_krishak_id: activity?.temp_krishak_id,
                                        quantity_given_id: activity?.data?.quantity_given_id,
                                        check_variety_id: activity?.data?.check_variety_id,
                                        research: activity?.data?.research,
                                        type_of_sample: activity?.data?.type_of_sample,
                                        is_s2s: activity?.data?.is_s2s,
                                        sample_distribution_near_retailer: activity?.data?.sample_distribution_near_retailer,
                                        remark: activity?.data?.remark,
                                        latitude: activity?.data?.latitude,
                                        longitude: activity?.data?.longitude,
                                        activity_image: activity_image
                                    }
                                }
                            }
                            activityArray.push(objRequest);
                        }

                        if (activity?.activity_type_id === ActivityType.GROUP_MEETING) {

                            let group_meeting_image = [];
                            for (let j = 0; j < activity?.data?.group_meeting_image.length; j++) {
                                const objImage = activity?.data?.group_meeting_image[j];
                                if (objImage.file !== undefined) {
                                    group_meeting_image.push(objImage.file.name);
                                }

                            }

                            let group_meeting_farmer_image = [];
                            for (let j = 0; j < activity?.data?.group_meeting_farmer_image.length; j++) {
                                const objImage = activity?.data?.group_meeting_farmer_image[j];
                                if (objImage.file !== undefined) {
                                    group_meeting_farmer_image.push(objImage.file.name);
                                }
                            }

                            let objRequest = {}
                            if (activity?.data === null) {
                                objRequest = {
                                    temp_activity_id: activity?.key,
                                    krishak_id: activity?.data?.krishak_id,
                                    activity_id: activity?.activity_id,
                                    activity_date: activity?.created_at,
                                    activity_type_id: activity?.activity_type_id,
                                    activity_status_id: activity?.activity_status_id,
                                    assigned_user_id: activity?.assigned_user_id,
                                    crop_id: activity?.crop_id,
                                    hybrid_id: activity?.hybrid_id,
                                    village_id: activity?.village_id,
                                    reporting_mobile: activity?.reporting_mobile,
                                    is_active: activity?.is_active,
                                    //data: activity?.data
                                }
                            } else {
                                objRequest = {
                                    temp_activity_id: activity?.key,
                                    krishak_id: activity?.data?.krishak_id,
                                    activity_id: activity?.activity_id,
                                    activity_date: activity?.created_at,
                                    activity_type_id: activity?.activity_type_id,
                                    activity_status_id: activity?.activity_status_id,
                                    assigned_user_id: activity?.assigned_user_id,
                                    crop_id: activity?.crop_id,
                                    hybrid_id: activity?.hybrid_id,
                                    village_id: activity?.village_id,
                                    reporting_mobile: activity?.reporting_mobile,
                                    is_active: activity?.is_active,
                                    data: {
                                        activity_id: activity?.activity_id,
                                        krishak_id: activity?.data?.krishak_id,
                                        temp_krishak_id: activity?.temp_krishak_id,
                                        season_id: activity?.data?.season_id,
                                        sub_activity_id: activity?.data?.sub_activity_id,
                                        is_farmer_attend: activity?.data?.is_farmer_attend,
                                        no_farmer_attend: activity?.data?.no_farmer_attend,
                                        is_retailer_attend: activity?.data?.is_retailer_attend,
                                        no_retailer_attend: activity?.data?.no_retailer_attend,
                                        is_prerak_attend: activity?.data?.is_prerak_attend,
                                        no_prerak_attend: activity?.data?.no_prerak_attend,
                                        farmer_commitment: activity?.data?.farmer_commitment,
                                        weight_unit_id: activity?.data?.weight_unit_id,
                                        prerak_commitment: activity?.data?.prerak_commitment,
                                        retailer_commitment: activity?.data?.retailer_commitment,
                                        group_meeting_farmer_phone: activity?.data?.group_meeting_farmer_phone,
                                        remark: activity?.data?.remark,
                                        latitude: activity?.data?.latitude,
                                        longitude: activity?.data?.longitude,
                                        group_meeting_farmer_image: group_meeting_farmer_image,
                                        group_meeting_image: group_meeting_image,
                                    }
                                }
                            }

                            activityArray.push(objRequest);
                        }
                        resolve(activityArray);
                    }
                } else {
                    resolve(activityArray);
                }
            });
        });

        const images = new Promise((resolve) => {
            SyncServices.getLocalActivities("is_synced", "false").then(activities => {
                let activity_images = [];
                if (activities != null || activities?.length > 0) {
                    //For Images
                    if (activities != null || activities?.length > 0) {
                        for (let i = 0; i < activities.length; i++) {
                            const activity = activities[i];
                            for (let j = 0; j < activity?.data?.activity_images?.length; j++) {
                                const objImage = activity?.data?.activity_images[j];
                                if (objImage.image_id === 0) {
                                    activity_images.push(objImage?.file);
                                }
                            }
                        }
                    }
                    Utilities.LogPrint("Images", activity_images);
                    resolve(activity_images);
                } else {
                    resolve(activity_images);
                }
            });
        });

        const groupMeetingImages = new Promise((resolve) => {
            SyncServices.getLocalActivities("is_synced", "false").then(activities => {
                let activity_images = [];
                if (activities != null || activities?.length > 0) {
                    //For Images
                    if (activities != null || activities?.length > 0) {
                        for (let i = 0; i < activities.length; i++) {
                            const activity = activities[i];
                            if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
                                for (let j = 0; j < activity?.data?.group_meeting_image?.length; j++) {
                                    const objImage = activity?.data?.group_meeting_image[j];
                                    activity_images.push(objImage?.file);
                                }
                            }
                        }
                    }
                    Utilities.LogPrint("Images", activity_images);
                    resolve(activity_images);
                } else {
                    resolve(activity_images);
                }
            });
        });

        const groupMeetingFarmerImages = new Promise((resolve) => {
            SyncServices.getLocalActivities("is_synced", "false").then(activities => {
                let activity_images = [];
                if (activities != null || activities?.length > 0) {
                    //For Images
                    if (activities != null || activities?.length > 0) {
                        for (let i = 0; i < activities.length; i++) {
                            const activity = activities[i];
                            if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
                                for (let j = 0; j < activity?.data?.farmerNumbersImageFiles?.length; j++) {
                                    const objImage = activity?.data?.farmerNumbersImageFiles[j];
                                    activity_images.push(objImage?.file);
                                }
                            }
                        }
                    }
                    Utilities.LogPrint("Images", activity_images);
                    resolve(activity_images);
                } else {
                    resolve(activity_images);
                }
            });
        });

        Promise.all([activities, images, groupMeetingImages, groupMeetingFarmerImages]).then((value) => {
            const activityArray = value[0];
            const activity_images = value[1];
            const group_meeting_image = value[2];
            const group_meeting_farmer_image = value[3];

            const lastSyncDate = localStorage.getItem(SYNC_SERVICE.ACTIVITY_LAST_SYNC_DATE);
            Utilities.LogPrint("LastSyncDate", lastSyncDate);
            const formData = new FormData();
            let lst_sync = [
                {
                    action: SYNC_SERVICE.ACTION_ADD_ACTIVITY,
                    last_sync_date: lastSyncDate,
                    //last_sync_date: "2021-04-22 20:11:43",
                    data: activityArray
                }
            ]
            formData.append("lst_sync", JSON.stringify(lst_sync));

            for (let i = 0; i < activity_images.length; i++) {
                formData.append("activity_image", activity_images[i]);
            }

            for (let i = 0; i < group_meeting_image.length; i++) {
                formData.append("group_meeting_image", group_meeting_image[i]);
            }
            for (let i = 0; i < group_meeting_farmer_image.length; i++) {
                formData.append("group_meeting_farmer_image", group_meeting_farmer_image[i]);
            }

            if (showLoading) {
                this.props.handleSyncLoading(true, SYNC_SERVICE.ACTIVITY_TABLE);
            }

            try {
                ApiServices.syncActivityData(formData)
                    .then(async response => {
                        //this.props.handleSyncLoading(false, SYNC_SERVICE.ACTIVITY_TABLE);
                        Utilities.LogPrint("API_DATA syncData: ---->", response);
                        if (response.success) {

                            let data = response.data;
                            if (data != null) {
                                let KEY = SYNC_SERVICE.ACTION_ADD_ACTIVITY;
                                const activitiesData = data.find(item => item.action === KEY);
                                Utilities.LogPrint("activitiesData Data", activitiesData.data);
                                localStorage.setItem(SYNC_SERVICE.LAST_SYNC_DATE, activitiesData?.last_sync_date);
                                localStorage.setItem(SYNC_SERVICE.ACTIVITY_LAST_SYNC_DATE, activitiesData?.last_sync_date);
                                for (let i = 0; i < activitiesData?.data.length; i++) {
                                    const activity = activitiesData?.data[i];
                                    if (activity !== null && data !== undefined) {

                                        // FOR INDIVIDUAL_VISIT & SAMPLE_DISTRIBUTION
                                        if (activity.activity_type_id === ActivityType.INDIVIDUAL_VISIT ||
                                            activity.activity_type_id === ActivityType.SAMPLE_DISTRIBUTION) {
                                            SyncServices.updateActivityWithServer(activity, "true");

                                            //*** Convert Image To Byte Array (For Showing Image In Local) ***//
                                            // if (activity?.data?.activity_images.length > 0) {
                                            //     for (const element of activity?.data?.activity_images) {
                                            //         const byteArray = await Utilities.getImageBytesFromUrl(element.image_url);
                                            //         Utilities.LogPrint("Update byteArray", byteArray);
                                            //         if (byteArray) {
                                            //             element.byteArray = byteArray;
                                            //         }
                                            //     }
                                            //     //Utilities.LogPrint("UPDATE Server With Images=== ", activity);
                                            //     SyncServices.updateActivityWithServer(activity, "true");
                                            // } else {
                                            //     //Utilities.LogPrint("UPDATE Server === ", activity);
                                            //     SyncServices.updateActivityWithServer(activity, "true");
                                            // }
                                        }

                                        // FOR GROUP_MEETING
                                        if (activity.activity_type_id === ActivityType.GROUP_MEETING) {
                                            //Utilities.LogPrint("GroupMeetingActivity ", activity);
                                            try {
                                                activity.data.group_meeting_farmer_phone = activity.group_meeting_farmer_phone;
                                            } catch (error) {
                                                //Utilities.LogPrint("GroupMeetingActivity ", error);
                                            }
                                            if (activity.data === null) {
                                                //Utilities.LogPrint("UPDATE Server === ", activity);
                                                SyncServices.updateActivityWithServer(activity, "true");
                                            }
                                            // else if (activity.group_meeting_farmer_image.length > 0) {
                                            //     activity.group_meeting_farmer_image.forEach((element, index) => {

                                            //         Utilities.getImageBytesFromUrl(element.image_url).then(result => {
                                            //             element.byteArray = result;

                                            //             if (index === (activity.group_meeting_farmer_image.length - 1)) {
                                            //                 if (activity.group_meeting_image.length > 0) {
                                            //                     activity.group_meeting_image.forEach((element, index) => {


                                            //                         Utilities.getImageBytesFromUrl(element.image_url).then(result => {
                                            //                             element.byteArray = result;

                                            //                             if (index === (activity.group_meeting_image.length - 1)) {
                                            //                                 activity.data.prerak_commitment = activity.prerak_commitment;
                                            //                                 activity.data.retailer_commitment = activity.retailer_commitment;
                                            //                                 activity.data.group_meeting_farmer_image = activity.group_meeting_farmer_image;
                                            //                                 activity.data.group_meeting_image = activity.group_meeting_image;
                                            //                                 SyncServices.updateActivityWithServer(activity, "true");
                                            //                             }
                                            //                         });
                                            //                     });
                                            //                 } else {
                                            //                     Utilities.LogPrint("UPDATE Server === ", activity);
                                            //                     SyncServices.updateActivityWithServer(activity, "true");
                                            //                 }
                                            //             }
                                            //         });
                                            //     });
                                            // } else if (activity.group_meeting_image.length > 0) {
                                            //     activity.group_meeting_image.forEach((element, index) => {

                                            //         Utilities.getImageBytesFromUrl(element.image_url).then(result => {
                                            //             element.byteArray = result;

                                            //             if (index === (activity.group_meeting_image.length - 1)) {
                                            //                 activity.data.prerak_commitment = activity.prerak_commitment;
                                            //                 activity.data.retailer_commitment = activity.retailer_commitment;
                                            //                 activity.data.group_meeting_farmer_image = activity.group_meeting_farmer_image;
                                            //                 activity.data.group_meeting_image = activity.group_meeting_image;
                                            //                 SyncServices.updateActivityWithServer(activity, "true");
                                            //             }
                                            //         });
                                            //     });
                                            // } 
                                            else {
                                                activity.data.prerak_commitment = activity.prerak_commitment;
                                                activity.data.retailer_commitment = activity.retailer_commitment;
                                                activity.data.group_meeting_farmer_image = activity.group_meeting_farmer_image;
                                                activity.data.group_meeting_image = activity.group_meeting_image;
                                                SyncServices.updateActivityWithServer(activity, "true");
                                            }
                                        }

                                        // FOR SAMPLE TO SALE
                                        if (activity.activity_type_id === ActivityType.SAMPLE_TO_SALE) {
                                            SyncServices.updateActivityWithServer(activity, "true");
                                        }
                                    }
                                }
                                //Utilities.LogPrint("MASTER", DataProvider.getInstance());
                                await DataProvider.getInstance().fetchMasterData();
                                if (showLoading) {
                                    this.props.handleSyncLoading(false, SYNC_SERVICE.ACTIVITY_TABLE);
                                }
                                //window.location.reload();
                                if (this.showSyncMessage) {
                                    toast.success(COMMON.SYNC_SUCCESSFUL);
                                }
                                this.checkLocalData();
                                this.props.handleSync();
                            }
                        } else {
                            //window.location.reload();
                            Utilities.LogPrint("Status", response.message);
                        }
                    }).catch(error => {
                        //window.location.reload();
                        if (showLoading) {
                            this.props.handleSyncLoading(false, SYNC_SERVICE.ACTIVITY_TABLE);
                        } Utilities.LogPrint("Status-Catch", error);
                    });
            } catch (error) {
                //window.location.reload();
                if (showLoading) {
                    this.props.handleSyncLoading(false, SYNC_SERVICE.ACTIVITY_TABLE);
                }
                //this.setState({ isSyncLoading: false });
            }
        });
    }

    _handleNotificationClick = () => {
        this.props.history.push({
            pathname: ALL_ROUTES.NOTIFICATIONS_ROUTE,
            state: { selectedTab: MORE_MENU_TYPES.NOTIFICATION, detail: true }
        })
    }

    _handleMoreMenuClick = () => {
        this.props.history.push(ALL_ROUTES.MORE_MENU_ROUTE);
    }

    handleSelect = (e) => {
        Utilities.LogPrint(e.target.name);
        this.props.history.push(this.getReportRoute(e.target.name));

        // SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_STATE, SYNC_SERVICE.MASTER_TABLE).then(data => {
        //     Utilities.LogPrint("allStatesData", data);           
        // });

    }

    getReportRoute(option) {
        switch (parseInt(option)) {
            case 1:
                return ALL_ROUTES.REPORTS_ROUTE;
            case 2:
                return ALL_ROUTES.GROUP_MEETING_REPORTS_ROUTE;
            case 3:
                return ALL_ROUTES.INDIVIDUAL_VISIT_REPORTS_ROUTE;
            case 4:
                return ALL_ROUTES.SAMPLE_DISTRIBUTION_REPORTS_ROUTE;
            case 5:
                return ALL_ROUTES.SAMPLE_TO_SALE_REPORTS_ROUTE;
            case 6:
                return ALL_ROUTES.PRERAK_REPORTS_ROUTE;
            case 7:
                return ALL_ROUTES.USER_STATUS_REPORTS_ROUTE;
            case 8:
                return ALL_ROUTES.FARMER_REPORTS_ROUTE;
            case 9:
                return ALL_ROUTES.USER_LOCATION_REPORTS_ROUTE;
            default:
                break;
        }
    }

    handleClearCache = () => {
        this.setState({ isLoading: true });
        setTimeout(() => {
            SyncServices.clearAllData();
            localStorage.setItem(SYNC_SERVICE.LAST_SYNC_DATE, COMMON_VALUE.DEFAULT_SYNC_DATE);
            localStorage.setItem(SYNC_SERVICE.ACTIVITY_LAST_SYNC_DATE, Utilities.getLastMonthDate());
            this.setState({ isLoading: false });
            this.props.handleSync();
            toast.success(COMMON.CLEAR_DATA_SUCCESSFUL);
        }, 1000);
    }


    render() {
        const { isLoading, selectedTab, localDataCount } = this.state;
        //const enabledGo = (mobileNumber.length === 10);

        const enabledGo = this.phoneValidation();

        const showDashboard = AuthService.getRoleAccess(PERMISSION_CONSTANTS.DASHBOARD_VIEW);
        const showHomeToday = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_ACTIVITY_INDIVIDUAL_VISIT);
        const showCalendar = AuthService.getRoleAccess(PERMISSION_CONSTANTS.CALENDAR);
        const showKrishak = AuthService.getRoleAccess(PERMISSION_CONSTANTS.ADD_KRISHAK);
        const showReports = AuthService.getRoleAccess(PERMISSION_CONSTANTS.KRISHAK_REPORT);
        const showPrerakReport = AuthService.getRoleAccess(PERMISSION_CONSTANTS.PRERAK_REPORT);
        const showUserStatusReport = AuthService.getRoleAccess(PERMISSION_CONSTANTS.USER_STATUS_REPORT);
        const showUserLocationReport = AuthService.getRoleAccess(PERMISSION_CONSTANTS.USER_LOCATION_REPORT);

        const notificationCount = DataProvider.getInstance().getNotificationCount();

        return (
            <div id="header">
                <section className="top-navbar">
                    <nav className="navbar navbar-expand-lg navbar-light bg-light">
                        <div className="container">
                            <a className="navbar-brand" href="" >
                                <img src={LOGO} className="img-fluid" onClick={this._handleTodayClick} alt="" />
                            </a>
                            <ul className="navbar-nav d-none d-lg-flex">
                                <li className={selectedTab === HeaderTypes.DASHBOARD ? "nav-item active" : "nav-item"}>
                                    <a className={`nav-link ${showDashboard?.view ? '' : 'd-none'}`} onClick={this._handleDashboardClick}>{COMMON.DASHBOARD} </a>
                                </li>
                                <li className={selectedTab === HeaderTypes.TODAY ? "nav-item active" : "nav-item"}>
                                    <a className={`nav-link ${showHomeToday?.view ? '' : 'd-none'}`} onClick={this._handleTodayClick}>{COMMON.TODAY} </a>
                                </li>
                                <li className={selectedTab === HeaderTypes.CALENDAR ? "nav-item active" : "nav-item"}>
                                    <a className={`nav-link ${showCalendar?.view ? '' : 'd-none'}`} onClick={this._handleCalendarClick}>{COMMON.CALENDER} </a>
                                </li>
                                <li className={selectedTab === HeaderTypes.KRISHAK ? "nav-item active" : "nav-item"}>
                                    <a className={`nav-link ${showKrishak?.view ? '' : 'd-none'}`} href="" data-toggle="modal" data-target={(selectedTab === HeaderTypes.KRISHAK) ? "" : "#farmerMobileModal"} >{COMMON.KRISHAK} </a>
                                </li>
                                <li className={selectedTab === HeaderTypes.REPORTS ? "nav-item active dropdown" : "nav-item dropdown"}>
                                    <a className={`nav-link ${showReports?.view ? '' : 'd-none'}`} href="#" onClick={this.handleSelect} role="button" id="dropdownMenuLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{COMMON.REPORTS}
                                        <span><i className="customic ic-down-arrow ml-3"></i></span>
                                    </a>
                                    <div className="dropdown-menu reports-menu p-0" onClick={this.handleSelect} aria-labelledby="dropdownMenuLink">
                                        <a className="dropdown-item" name={1} >{COMMON.KRISHAK}</a>
                                        <a className="dropdown-item" name={2} >{CALENDER_SCREEN.GROUP_MEET}</a>
                                        <a className="dropdown-item" name={3} >{CALENDER_SCREEN.INDIVIDUAL_VISIT}</a>
                                        <a className="dropdown-item" name={4} >{CALENDER_SCREEN.SAMPLE_DISTRIBUTION}</a>
                                        <a className="dropdown-item" name={5} >{CALENDER_SCREEN.SAMPLE_TO_SALE}</a>
                                        <a className={`dropdown-item ${showPrerakReport?.view ? '' : 'd-none'}`} name={6} >{COMMON.PRERAK}</a>
                                        <a className={`dropdown-item ${showUserStatusReport?.view ? '' : 'd-none'}`} name={7} >{COMMON.USER_STATUS}</a>
                                        <a className="dropdown-item" name={8} >{COMMON.FARMER_REPORT}</a>
                                        <a className={`dropdown-item ${showUserLocationReport?.view ? '' : 'd-none'}`} name={9} >{REPORTS_SCREEN.USER_LOCATION}</a>
                                    </div>
                                </li>
                            </ul>

                            {/* Right side nav options */}
                            <ul className="navbar-nav ml-auto">

                                {showKrishak?.view ?
                                    <li className="nav-item menu-notification-link">
                                        <a className="nav-link px-2" >
                                            <i className="customic ic-sync-icon" onClick={this._handleSyncClick}></i>
                                            <span className={(localDataCount === 0) ? "d-none" : "sync-count"}></span>
                                        </a>
                                    </li> : null
                                }

                                {showKrishak?.view ?
                                    <li className="nav-item menu-notification-link">
                                        <a className="nav-link px-2" >
                                            <i
                                                className="customic ic-cache-icon"
                                                data-toggle="modal"
                                                data-target="#ConfirmPopup"></i>
                                        </a>
                                    </li> : null
                                }


                                {/* <li className="nav-item menu-notification-link">
                                    <a className="nav-link px-2 refresh" href="#">
                                        <i className="customic ic-notification"></i>
                                    </a>
                                </li> */}

                                <li className="nav-item menu-notification-link">
                                    <a className="nav-link px-2" >
                                        <i className="customic ic-notification" onClick={this._handleNotificationClick}></i>
                                        <span className={(notificationCount === 0) ? "d-none" : "nav-notification-count"}>{notificationCount}</span>
                                    </a>
                                </li>
                                <li className="nav-item menu-more-link d-none d-lg-block">
                                    <a className="nav-link pr-0 pl-3" >
                                        <i href="" className="customic ic-more" onClick={this._handleMoreMenuClick}></i>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </section>
                {/* MOBILE NUMBER POPUP */}
                <div className="modal fade bottom-drawer" id="farmerMobileModal" role="dialog" aria-hidden="true">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-body">
                                <button type="button" className="close d-none d-md-block" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                                <h6 className="font-weight-medium">{HOME_TODAY_SCREEN.ENTER_THE_MOBILE_NUMBER_OF_THE_FARMER}</h6>
                                <form action="">
                                    <div className="form-group mobile-number-input">
                                        <label>+91 -</label>
                                        <input
                                            type="phone"
                                            className="form-control"
                                            placeholder=""
                                            maxLength="10"
                                            onChange={this.verifyNumber} />
                                    </div>
                                    {!enabledGo ?
                                        <div className='error'>{COMMON.VALID_PHONE_NUMBER}</div> : null
                                    }

                                    <button className="btn btn-primary w-100 mb-2"
                                        onClick={this._handleKrishakClick}
                                        data-dismiss="modal"
                                        disabled={!enabledGo}
                                    >{HOME_TODAY_SCREEN.GO}</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
                {isLoading ? <Loader /> : null}
                {this.showConformPopup()}

                {/* For Krishak Update */}
                {this.showKrishakUpdatePopup()}
                <button id="krishakButton" type="button" data-toggle="modal" data-target="#krishakUpdate"
                    className="d-none">placeholder</button>

            </div>
        )
    }

    showConformPopup = () => {
        return (
            <div className="modal fade bottom-drawer" id="ConfirmPopup" role="dialog" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body my-4">

                            <p>Are you sure you want to clear the data ? </p>
                            <div className="d-flex grey-btn">
                                <button className="btn btn-secondary w-50 mr-2" data-dismiss="modal" aria-label="Close" onClick={this.handleClearCache}>Yes</button>
                                <button className="btn btn-secondary w-50 mr-2" data-dismiss="modal" aria-label="Close">No</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    showKrishakUpdatePopup = () => {
        return (
            <div className="modal fade bottom-drawer" id="krishakUpdate" role="dialog" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body my-4">
                            <p>Krishak Already Exists. Do you want to update the krishak? </p>
                            <div className="d-flex grey-btn">
                                <button className="btn btn-secondary w-50 mr-2" data-dismiss="modal" aria-label="Close">Cancel</button>
                                <button className="btn btn-secondary w-50 mr-2" data-dismiss="modal" aria-label="Close" onClick={this.handleUpdateKrishak}>Update</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

//export default Header;
export default withRouter(Header)
